import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-accept-terms-check',
  templateUrl: './accept-terms-check.component.html',
  styleUrls: ['./accept-terms-check.component.css']
})
export class AcceptTermsCheckComponent implements OnInit {

  @Input() label;
  @Input() url;

  checked = false;
  indeterminate = false;
  labelPosition: 'before' | 'after' = 'after';

  @Input() version;
  @Input() type;
  @Output() policyChecked = new EventEmitter(); // Emit event when CTA is clicked

  constructor() { }

  ngOnInit(): void {
  }

  onPrivacyChecked(){
    this.policyChecked.emit(this.checked);
  }

  getType(type){
    return this.type == type;
  }

}
